import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Scenes } from '../../../pages/scenes/Scenes';

export const Route = createFileRoute('/_private/_home/scene')({
  component: ScenesRoute,
});

function ScenesRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Scenes portalApiClient={apiClient} />;
}
